import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { showError, showInfo } from '../../services/notification.service';

interface ErrorLoadingDataNotificationProps {
  dataError?: FetchBaseQueryError | SerializedError;
}

const ErrorLoadingDataNotification = ({ dataError }: ErrorLoadingDataNotificationProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!dataError) return;

    if (isFetchBaseQueryError(dataError)) {
      if (dataError?.status === 'CUSTOM_ERROR' && dataError?.error === 'OFFLINE_NO_DATA') {
        showInfo(t('offline-no-data', 'Unable to retrieve data while offline'), { id: 'record-list-offline-no-data' });
        return;
      }
    }

    showError(t('error-loading-data'));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataError]);

  return null;
};

export default React.memo(ErrorLoadingDataNotification);

function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}
